import {
  createActions,
  createRequestTypes,
} from 'app/store/actions/base-request.actions'

export const EBOOKS_ACTIONS = createRequestTypes('[Media] EBOOKS')
export const BIBLIOTECA_ACTIONS = createRequestTypes('[Media] BIBLIOTECA')
export const CAMINOS_ACTIONS = createRequestTypes('[Media] CAMINOS')
export const CAMINOS_3_CA_ACTIONS = createRequestTypes('[Media] CAMINOS 3 CA')
export const TEXAS_ELAR_ACTIONS = createRequestTypes('[Media] TEXAS ELAR')
export const TEXAS_SLAR_ACTIONS = createRequestTypes('[Media] TEXAS SLAR')
export const TEXAS_ELAR_2E_ACTIONS = createRequestTypes('[Media] TEXAS ELAR 2E')
export const TEXAS_SLAR_2E_ACTIONS = createRequestTypes('[Media] TEXAS SLAR 2E')

export const ebooksActionCreators = createActions(EBOOKS_ACTIONS)
export const bibliotecaActionCreators = createActions(BIBLIOTECA_ACTIONS)
export const caminosActionCreators = createActions(CAMINOS_ACTIONS)
export const caminos3CAActionCreators = createActions(CAMINOS_3_CA_ACTIONS)
export const texasElarActionCreators = createActions(TEXAS_ELAR_ACTIONS)
export const texasSlarActionCreators = createActions(TEXAS_SLAR_ACTIONS)
export const texasElar2EActionCreators = createActions(TEXAS_ELAR_2E_ACTIONS)
export const texasSlar2EActionCreators = createActions(TEXAS_SLAR_2E_ACTIONS)
